<app-form-field
  [formGroup]="form"
  [showError]="(submitted || form.controls.flip.touched) && form.controls.flip.invalid"
>
  <label class="!text-[14px]" app-label translate>trilhas.estudio.trilha.anexo-principal</label>
  <input app-input type="url" formControlName="flip" (change)="onSend()" [placeholder]="'trilhas.link' | translate" />
</app-form-field>
